module.exports = __webpack_public_path__ + "static/chrischuras-bfcf7685a649760ed141af3d6bbc1c6e.png";